import { render } from "./Sidebar.vue?vue&type=template&id=68e0e772"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68e0e772"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68e0e772', __exports__)) {
    api.reload('68e0e772', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=68e0e772", () => {
    api.rerender('68e0e772', render)
  })

}


export default __exports__